import { Provider } from './shared.types';

/**
 * The `code` on the 409 the backend answers with when a provider disconnect,
 * a brand delete or a location delete would strand orders still waiting for
 * the provider's payment report.
 */
export enum UnpaidReportOrdersCode {
  /** Admin and support: confirmable by repeating the call with
   *  `confirmUnpaidOrders: true`. */
  confirm = 'UNPAID_REPORT_ORDERS',
  /** Partner and sales apps: cannot confirm, the message tells them to
   *  contact support. */
  contactSupport = 'UNPAID_REPORT_ORDERS_CONTACT_SUPPORT',
}

export type UnpaidReportOrder = {
  orderId: number;
  number: string;
  brandId: number;
  /** Uber Eats or Grubhub per the spec, but the dev backend has also sent
   *  GloriaFood orders here - so any provider. */
  provider: Provider;
  createdAt: string;
  /** Cents. */
  subTotal: number | null;
  /** Cents: what the location is paid for this order if it is paid out from
   *  the subtotal - the same calculation the backend books on Confirm. Null
   *  when the backend could not work it out; absent from backends older than
   *  the field. Shown as is, never calculated here. */
  clientGets?: number | null;
};

export type UnpaidReportOrders = {
  code: UnpaidReportOrdersCode;
  /** Written for the user, shown as is. */
  message: string;
  count: number;
  /** Cents, the sum of the orders' subtotals. */
  subTotal: number;
  /** Cents, the sum of the orders' `clientGets` (a null one is left out).
   *  Absent from backends older than the field. */
  clientGets?: number;
  orders: UnpaidReportOrder[];
};
